<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="680px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-container class="flex just-center">
        <el-form
          ref="form"
          :model="params"
          :rules="rules"
          label-width="240px"
          label-position="right"
        >
          <el-form-item label="任务类型:" prop="ctype">
            <el-select v-model.number="params.ctype" placeholder="请选择" clearable>
              <el-option :value="0" label="每日任务"></el-option>
              <el-option :value="1" label="萌新任务"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="福利类型：" prop="dtype">
            <el-select v-model.number="params.qtype" placeholder="请选择">
              <el-option :value="0" label="请选择"></el-option>
              <el-option  v-for="(item,index) in qtypeList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务类型：" prop="dtype">
            <el-select v-model.number="params.dtype" placeholder="请选择">
              <el-option :value="0" label="请选择"></el-option>
              <el-option  v-for="(item,index) in typeList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图" prop="img">
            <base-upload
                class="upload"
                :key="params.img"
                :cover="params.img"
                :action="baseConfig.baseServerUrl + '/agent/upload/static'"
                :wSize="45"
                :hSize="45"
                :width="'45px'"
                :height="'45px'"
                @successCallback="handleUploadSuccess"
            ></base-upload>
          </el-form-item>
          <el-form-item label="标题：" prop="name">
            <el-input v-model="params.name" placeholder="请输入" maxlength="30"  size="medium"></el-input>
          </el-form-item>
          <el-form-item label="描述：" prop="desc">
            <el-input v-model="params.desc" placeholder="请输入" maxlength="100"  size="medium"></el-input>
          </el-form-item>
          <el-form-item label="可获得积分：" prop="points" v-if="params.qtype == 1">
            <el-input v-model.number="params.points" placeholder="请输入" maxlength="10" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="可获VIP天数：" prop="points" v-if="params.qtype == 2">
            <el-input v-model.number="params.points" placeholder="请输入" maxlength="10" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="观影券数量：" prop="qnum" v-if="params.qtype == 3">
            <el-input v-model.number="params.qnum" placeholder="请输入" maxlength="10" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="观影券面值：" prop="qprice" v-if="params.qtype == 3">
            <el-input v-model.number="params.qprice" placeholder="请输入" maxlength="10" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sorted">
            <el-input type="number" v-model.number="params.sorted" size="medium" placeholder="请输入" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="跳转链接：" prop="href">
            <el-select v-model="params.href">
              <el-option value="" label="请选择"></el-option>
              <el-option
                  v-for="(item, idx) in JUMPLIST()"
                  :label="item.label"
                  :value="item.value"
                  :key="idx"
              ></el-option>
            </el-select>
            <el-input v-model="params.href" placeholder="请输入" maxlength="100"  size="medium"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="status" placeholder="请选择">
            <el-select v-model.number="params.status">
              <el-option
                  v-for="(item, idx) in statusList"
                  :label="item.label"
                  :value="item.value"
                  :key="idx"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="flag"
                size="small"
            >确 认</el-button
            >
          </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api/checkTaskApi";
import {validatorIndex} from "@/utils/validator";
import {JUMPLIST} from "@/utils/constants";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  computed: {
    baseConfig() {
      return baseConfig
    }
  },
  data() {
    return {
      dialogVisible: false,
      labelPosition: "left",
      title: "",
      flag: false,
      id: "",
      type: "",
      statusList: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
      qtypeList: [
        {label: '获取积分', value: 1},
        //{label: '获取VIP', value: 2},
        //{label: '获取观影券', value: 3},
      ],
      typeList:[
        {label:"每日登陆",value:1},
        {label:"每日发帖",value:2},
        {label:"每日评论",value:3},
        {label:"下载应用",value:4},
        {label:"购买VIP",value:5},
        {label:"购买金币作品",value:6},
        {label:"保存账号凭证",value:7},
        {label:"每日邀请",value:8},
        {label:"每日点赞",value:9},
        {label:"充值金币",value:10},
        {label:"每日收藏",value:11},
      ],
      params: {
        id: "",
        name: '',
        desc: '',
        href:'' ,
        img:'' ,
        qnum:1 ,
        qprice:0 ,
        dtype:0 ,
        qtype:0,
        ctype:0,
        points:0 ,
        sorted: 1,
        status: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择开关状态", trigger: "blur" },
        ],
      },
    };
  },

  watch:{
    params: {
      handler(newVal) {
        if(!this.params.name)this.params.name = this.typeList.find(c=>c.value==newVal.dtype).label
      },
      deep: true // 深度监听
    }
  },

  methods: {
    JUMPLIST() {
      return JUMPLIST
    },
    // 标签封面上传成功回掉
    handleUploadSuccess(res) {
      this.params.img = res.data.coverImg;
      this.$forceUpdate();
    },

    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.handleSave();
          } else {
            this.handleEdit();
          }
        } else {
          return false;
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: "",
        name: '',
        desc: '',
        href:'' ,
        dtype:0 ,
        ctype:0,
        points:0 ,
        qtype:0,
        qnum:1 ,
        qprice:0 ,
        sorted: 1,
        status: 0,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑福利任务";
        this.params.id = data.id;
        this.params.name = data.name;
        this.params.desc = data.desc;
        this.params.dtype = data.dtype;
        this.params.ctype = data.ctype;
        this.params.qtype = data.qtype;
        this.params.points = data.points;
        this.params.sorted = data.sorted;
        this.params.status = data.status;
        this.params.qnum = data.qnum;
        this.params.qprice = data.qprice;
        this.params.href = data.href;
        this.params.img = data.img;
        this.$forceUpdate();
      } else {
        this.title = "新增福利任务";
        this.params = {
          id: "",
          name: '',
          desc: '',
          href:'' ,
          img:'' ,
          dtype:0 ,
          qtype:0 ,
          ctype:0 ,
          qnum:1 ,
          qprice:0 ,
          points:0 ,
          sorted: 1,
          status: 0,
        }
      }
    },
    // 新增
    handleSave() {
      API.save(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑
    handleEdit() {
      let form = Object.assign(this.params);
      API.update(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 240px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
